import { Modal } from "antd";
import React, { useEffect, useState } from "react";

const CustomModal = ({ isModalOpen, closeModal, children, title, okText, submit, disable, footer, cssClassName, closable, className="" }) => {
	const [openModal, setOpenModal] = useState(isModalOpen);

	const handleCancel = () => {
		setOpenModal(false);
		if (typeof closeModal === "object") {
			closeModal.map((func) => func(false));
		} else if(closeModal) {
			closeModal(false)
		}
	};

	useEffect(() => {
		setOpenModal(isModalOpen)
	}, [isModalOpen]);

	return (
		<div>
			<Modal
				className={className}
				title={title}
				destroyOnClose={true}
				bodyStyle={{ overflowY: "auto", marginTop: "5px", maxHeight: "75vh" }}
				centered
				maskClosable={false}
				wrapClassName={cssClassName}
				okText={okText}
				open={openModal}
				onOk={(event) => {
					submit();
					handleCancel(false);
				}}
				closable={closable}
				onCancel={handleCancel}
				cancelButtonProps={{
					className: "custom-cancel-button", // Additional class for the cancel button
				}}
				okButtonProps={{ disabled: disable }}
				footer={footer}
			>
				{children}
			</Modal>
		</div>
	);
};

export default CustomModal;
